/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LikeDto } from '../../models/like-dto';

export interface LikeControllerFindById$Params {
  id: string;
}

export function likeControllerFindById(http: HttpClient, rootUrl: string, params: LikeControllerFindById$Params, context?: HttpContext): Observable<StrictHttpResponse<LikeDto>> {
  const rb = new RequestBuilder(rootUrl, likeControllerFindById.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<LikeDto>;
    })
  );
}

likeControllerFindById.PATH = '/api/like/{id}';
